import { PropsWithChildren, useState } from "react"
import { AppEvent } from "../types"
import useAppEventProviderSse from "./useAppEventProvider.sse"
import useAppEventProviderActions, { AppEventProviderActionsProps } from "./useAppEventProvider.actions"

export type useAppEventProviderProps = PropsWithChildren<unknown>
export type AppEventProviderProps = AppEventProviderActionsProps & {
    events: AppEvent[]
}

const useAppEventProvider = (props: useAppEventProviderProps): AppEventProviderProps => {
    const [events, setEvents] = useState<AppEvent[]>([])
    const actionsProps = useAppEventProviderActions(events, setEvents)
    useAppEventProviderSse(actionsProps)

    return {
        ...props,
        events,
        ...actionsProps,
    }
}
export default useAppEventProvider
